$(function(){
    $.fn.cashProfile=function(options){
        var methods={};
        var html_type={
            "big":
            '<div class="photo"></div>'+
            '<div class="level">'+
                '<div class="in"></div>'+

            '</div>'+
            '<div class="progressBar">'+
                '<div class="fillBorder custom">'+
                    '<div class="fill"></div>'+
                    '<div class="flexColumnCenterAround fourDirection">'+
                        '<div class="text progressTextJS">'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</div>',
            "medium":
            '<div class="photo"></div>'+
            '<div class="level">'+
                '<div class="in"></div>'+
            '</div>'+
            '<div class="progressBar">'+
                '<div class="fillBorder">'+
                    '<div class="fill"></div>'+
                '</div>'+
                '<div class="textWrap">'+
                    '<div class="text progressTextJS">'+
                    '</div>'+
                '</div>'+
            '</div>',
            
        };
        function init(th,set){
            
            var girl_data=th.data(),i,row_keys=["cash_id","film_have","film_end","level"];
            if(typeof set.cashArr.cash_id=="undefined"){
                for(i in row_keys){
                    girl_data[row_keys[i]]=intval(girl_data[row_keys[i]]);
                }
            }
            else{
                girl_data=copyObj(set.cashArr);
                var arr={},i;
                for(i in girl_data){
                    arr["data-"+i]=girl_data[i];
                }
                th.attr(arr).addClass(set.size);
            }
            var html=html_type[set["size"]];
            var qwidth=(girl_data.film_have/girl_data.film_end*100);
            if(girl_data.level>=girl_data.level_max){
                qwidth=100;
            }
            html=$("<div>"+html+"</div>").find(".level>.in").html(girl_data.level).end()
            .find(".progressTextJS").html(numberFormat(girl_data.film_have)+" / "+numberFormat(girl_data.film_end)).end()
            .find(".photo").css("background-image",("url("+_IMG_SERV+"/gfx/place/cash/build/"+girl_data.cash_id+".png)")).end()
            .find(".progressBar .fill").css("width",qwidth+"%").end().html();
            th.html("").append(html);
            
        }
        
        var last_this=$(this); 
        var arg =Array.prototype.slice.call(arguments,1);
        return this.filter(".cashProfile").each(function(){
            var $this = $(this);
            if(methods[options]){  
                arg.unshift($this);
                return methods[options].apply($this,arg);
            }
            else if (typeof options === 'object' || !options){ 
                var data = $this.data("cashProf");  
                if(!data){    
                    data = $.extend( {
                       "size":"big",
                       "cashArr":[],//set here on in div
                        
//                        repeat_last:0,//how many px show from previous page
                    }, options);
                   
                }  
                else{
                     data = $.extend(data,options);
                }
                $this.data("cashProf", data);
                init($this,data); 
                return;
            }
            else{
                $.error('myPageSelector: no method: '+ options);
            } 
        });
    };
});